import React, { Component } from 'react';
import BusinessLandingHeader from './BusinessLandingHeader.jsx';
import BusinessLandingFooter from './BusinessLandingFooter.jsx';
import TextInput from '../common/TextInput';
import AlertDismissable from '../common/AlertDismissable';

export default class businessContactUs extends Component {
  constructor(props) {
    super(props);
    this.initialFormData = {
      name: '',
      email: '',
      companyname: '',
      mobilenumber: '',
      country: '',
      message: ''
    };
    this.formData = {
      ...this.initialFormData
    };
    this.errors = {
      name: '',
      email: '',
      companyname: '',
      mobilenumber: '',
      country: '',
      message: ''
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onFieldChange = this.onFieldChange.bind(this);
  }

  componentWillMount() { }

  componentWillUnmount() { }

  onFieldChange(value, name) {
    //alert('am here')
    this.setState({ formError: false });
    this.formData[name] = value;
    this.errors[name] = value ? false : true;
  }

  onFieldChangeMessage() {
    this.formData.message = document.getElementById('messageData').value;
  }

  onSubmit() {
    this.props.actions.contactUs(this.formData);
    if (this.props.authReducer.statusMessage.indexOf('succesfully') !== -1) {
      this.contactFormRef.reset();
    }
  }

  render() {
    const { router, authReducer } = this.props;
    return (
      <div className="business-body">
        <BusinessLandingHeader router={this.props.router} activeLink={false} metaTagKey={'contact-us'} />
        <div className="main-wrapper-business">
          <div className="faq-banner">
            <div className="faq-img">
              <img src="images/contact.png" />
            </div>
            <div className="faq-desc">
              <h1> Contact Us </h1>
              <p> We'd love to hear from you. </p>
            </div>
          </div>
          <div className="contactWrapper">
            <div className="container">
              <div className="row">
                <div className="col-sm-5 removePaddingLeft">
                  <h4>Message Us</h4>
                  {authReducer &&
                    authReducer.showErrorMessage &&
                    <AlertDismissable
                      bsStyle={
                        authReducer.statusMessage.indexOf('succesfully') !== -1 ? 'success ' : 'danger error-back'
                      }
                      closeLabel="Close alert"
                      closeAction={this.props.actions.hideErrorMessage}
                    >
                      <p> <i className="mdi mdi-block-helper " /> {authReducer.statusMessage} </p>
                    </AlertDismissable>}
                  <form ref={el => this.contactFormRef = el}>
                    <div className="material-input">
                      <div className="form-group">
                        <TextInput
                          type="text"
                          label="Name"
                          name="name"
                          showValidationError={this.errors['name']}
                          validationError="Please enter the name"
                          onBlur={this.onFieldChange.bind(this)}
                        />
                      </div>
                    </div>
                    <div className="material-input">
                      <div className="form-group">
                        <TextInput
                          type="email"
                          label="Email"
                          name="email"
                          validationError="Please enter your email id"
                          showValidationError={this.errors['email']}
                          onChange={this.onFieldChange.bind(this)}
                        />

                      </div>
                    </div>
                    {/*<div className="material-input">
                                <div className="form-group">
                                    <TextInput
                                      type="text"
                                      label="Company Name"
                                      name="companyname"
                                      showValidationError={this.errors['companyname']}
                                      validationError="Please enter the Company Name"
                                      onBlur={this.onFieldChange.bind(this)} />
                                </div>
                            </div>*/}
                    <div className="material-input">
                      <div className="form-group">
                        <TextInput
                          type="text"
                          label="Mobile Number"
                          name="mobilenumber"
                          showValidationError={this.errors['mobilenumber']}
                          validationError="Please enter the Mobile Number"
                          onBlur={this.onFieldChange.bind(this)}
                        />
                      </div>
                    </div>
                    {/*<div className="material-input">
                                <div className="form-group">
                                    <TextInput
                                      type="text"
                                      label="Country"
                                      name="country"
                                      showValidationError={this.errors['country']}
                                      validationError="Please enter the Country"
                                      onBlur={this.onFieldChange.bind(this)} />
                                </div>
                            </div>*/}
                    <div className="material-input">
                      <div className="form-group">
                        <textarea
                          className="form-control"
                          id="messageData"
                          onBlur={this.onFieldChangeMessage.bind(this)}
                          label="message"
                          name="message"
                        />
                        <span className="bar" />
                        <label>Message</label>
                      </div>
                    </div>
                    <div className="form-group">
                      <input className="btn-business btnSumbit" onClick={() => this.onSubmit(this)} value="MESSAGE" />
                    </div>
                  </form>
                </div>
                <div className="col-sm-6 col-sm-offset-1">
                  <h4>Reach out to Us</h4>
                  <div className="reachUsItem">
                    <div className="label">
                      Contact
                    </div>
                    <div className="labelContent">
                      <a href="tel:971543040110">+971 54 3040110</a>
                    </div>
                  </div>
                  <div className="reachUsItem">
                    <div className="label">
                      Location
                    </div>
                    <div className="labelContent">
                      <address>
                        Technohub 1,2<br />
                        Dubai Silicon Oasis
                      </address>
                    </div>
                  </div>
                  <div className="reachUsItem">
                    <div className="label">
                      Email
                    </div>
                    <div className="labelContent">
                      <a href="mailto:info@carcility.com">info@carcility.com</a>
                    </div>
                  </div>
                  <div className="reachUsItem">
                    <iframe src="https://www.google.com/maps/d/embed?mid=1h78UTJ7XtRgvwOL5K5v6KzGUZm4&amp;hl=en_US" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <BusinessLandingFooter {...this.props}/>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BusinessLanding/businessContactUs.jsx